import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, ResponseContentType, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {PieceJointe} from './piece-jointe.model';
import {DateUtils} from 'ng-jhipster';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class PieceJointeService {

    private resourceUrl = 'api/piece-jointes';
    private publicResourceUrl = 'api/public/piece-jointes';
    private resourceDownloadUrl = 'api/download';

    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }

    constructor(private http: Http, private dateUtils: DateUtils, private sanitizer: DomSanitizer) { }

    create(pieceJointe: PieceJointe): Observable<PieceJointe> {
        let copy: PieceJointe = Object.assign({}, pieceJointe);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(pieceJointe: PieceJointe): Observable<PieceJointe> {
        let copy: PieceJointe = Object.assign({}, pieceJointe);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<PieceJointe> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            return this.buildPieceJointe(res);
        });
    }


    findByReferent(referentId: number, referentKey: String, pieceId, candidatureId: number): Observable<PieceJointe> {
        return this.http.get(`${this.publicResourceUrl}/referent/${referentId}/${pieceId}/${candidatureId}/${referentKey}`)
            .map((res: Response) => {
            return this.buildPieceJointe(res);
        });
    }

    private buildPieceJointe(res: Response): PieceJointe {
        let jsonResponse = res.json();
        jsonResponse.dateCreation = this.dateUtils
            .convertDateTimeFromServer(jsonResponse.dateCreation);
        jsonResponse.dateModification = this.dateUtils
            .convertDateTimeFromServer(jsonResponse.dateModification);
        jsonResponse.dateConformite = this.dateUtils
            .convertDateTimeFromServer(jsonResponse.dateConformite);
        return jsonResponse;
    }


    openFile(name: string): Observable<any> {
        let params = new URLSearchParams();
        params.set('name', name);
        return this.http.get(this.resourceDownloadUrl, { search: params, responseType: ResponseContentType.Blob }).map(
            (res) => {
                name = name.toLowerCase();
                if (name.endsWith('.pdf')) {
                    return new Blob([res.blob()], {type: 'application/pdf'});
                } else if (name.endsWith('.jpg') || name.endsWith('.jpeg')) {
                    return new Blob([res.blob()], {type: 'image/jpeg'});
                } else if (name.endsWith('.docx') || name.endsWith('.doc')) {
                    return new Blob([res.blob()], {type: 'application/msword'});
                } else if (name.endsWith('.png')) {
                    return new Blob([res.blob()], {type: 'image/png'});
                }
            });
    }

    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req.candidatureFormationId) {
            params.set('candidatureFormationId', req.candidatureFormationId);
        }
        return this.http.get(this.resourceUrl, { search: params })
            .map((res: any) => this.convertResponse(res))
        ;
    }

    findPieceIdentite(candidatureFormationId: number): Observable<Response> {
        let params = new URLSearchParams();
        params.set('candidatureFormationId', String(candidatureFormationId));
        return this.http.get(this.resourceUrl + '/pieceIdentite', { search: params })
            .map((res: any) => this.convertResponse(res))
            ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }


    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].dateCreation = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateCreation);
            jsonResponse[i].dateModification = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateModification);
            jsonResponse[i].dateConformite = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateConformite);
        }
        res._body = jsonResponse;
        return res;
    }

    initPDFOrImageFile(blob: Blob, piece: any) {
        let fileURL = URL.createObjectURL(blob);
        let name = piece.nom.toLowerCase();
        if (name.endsWith('.pdf')) {
            piece.content = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
        } else if (name.endsWith('.png') || name.endsWith('.jpg') || name.endsWith('.jpeg')) {
            piece.image = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/piece-jointe/piece-jointe.service.ts